import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';

import { ErrorPage } from './pages/ErrorPage';
import { SetupPage } from './pages/SetupPage';
import { ObsoleteAppointmentPage } from './pages/ObsoleteAppointmentPage';
import { ObsoleteBookingPage } from './pages/ObsoleteBookingPage';
import { AppointmentSummaryPage } from './pages/AppointmentSummaryPage';
import { AppointmentMoveConfPage } from './pages/AppointmentMoveConfPage';
import { AppointmentBookedPage } from './pages/AppointmentBookedPage';
import { NewAppointmentPage } from './pages/NewAppointmentPage';
import { StartPage } from './pages/StartPage';
import { LoginPatientPage } from './pages/LoginPatientPage';
import { ProceduresPage } from './pages/ProceduresPage';
import { PractitionersPage } from './pages/PractitionersPage';
import { EmergencyPage } from './pages/EmergencyPage';
import { DateTimeEntryPage } from './pages/DateTimeEntryPage';
import { BillPage } from './pages/BillPage';
import { PatientDashboardPage } from './pages/PatientDashboardPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { InstrSurgeryPage } from './pages/InstrSurgeryPage';
import { HomebleachingPage } from './pages/HomebleachingPage';
import { AgendaPage } from './pages/AgendaPage';
import { AgendaWeeklyPage } from './pages/AgendaWeeklyPage';
import { AdminBookingPage } from './pages/AdminBookingPage';
import { NewPatientDataPage } from './pages/NewPatientDataPage';
import { RegistrationDonePage } from './pages/RegistrationDonePage';
import { CancellationPage } from './pages/CancellationPage';
import { CancellationDonePage } from './pages/CancellationDonePage';
import { AppointmentChainPage } from './pages/AppointmentChainPage';
import { ProfilePage } from './pages/ProfilePage';
import { ContactPage } from './pages/ContactPage';
import { ObsoleteRegistrationPage } from './pages/ObsoleteRegistrationPage';
import { RegistrationCodePage } from './pages/RegistrationCodePage';
import { ForgottenPasswordPage } from './pages/ForgottenPasswordPage';
import { EmailSentPage } from './pages/EmailSentPage';
import { TfaEntryPage } from './pages/TfaEntryPage';
import { SetPasswordPage } from './pages/SetPasswordPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { DirectionsPage } from './pages/DirectionsPage';
import './PortalPatientMobile.css';
import './PatientAppointmentMobile.css';
//import { MonthlyCalendarPage } from './pages/MonthlyCalendarPage';

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: '/',
    element: <StartPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/start',
    element: <StartPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/login',
    element: <LoginPatientPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/register',
    element: <ObsoleteRegistrationPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/registration-code',
    element: <RegistrationCodePage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/set-password',
    element: <SetPasswordPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/forgotten-password',
    element: <ForgottenPasswordPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/email-sent',
    element: <EmailSentPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/tfa-entry',
    element: <TfaEntryPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/datenschutz',
    element: <PrivacyPolicyPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'directions',
        element: <DirectionsPage />,
      },
      {
        path: 'setup',
        element: <SetupPage />,
      },
      {
        path: 'appointments-old',
        element: <ObsoleteAppointmentPage />,
      },
      {
        path: 'booking',
        element: <ObsoleteBookingPage />,
      },
      {
        path: 'appointment-summary',
        element: <AppointmentSummaryPage />,
      },
      {
        path: 'move-conf',
        element: <AppointmentMoveConfPage />,
      },
      {
        path: 'appointment-booked',
        element: <AppointmentBookedPage />,
      },
      {
        path: 'appointments',
        element: <NewAppointmentPage />,
      },
      {
        path: 'dashboard',
        element: <PatientDashboardPage />,
      },
      {
        path: 'documents',
        element: <DocumentsPage />,
      },
      {
        path: 'bills',
        element: <BillPage />,
      },
      {
        path: 'procedures',
        element: <ProceduresPage />,
      },
      {
        path: 'practitioners',
        element: <PractitionersPage />,
      },
      {
        path: 'emergency',
        element: <EmergencyPage />,
      },
      {
        path: 'date-time-entry',
        element: <DateTimeEntryPage />,
      },
      {
        path: 'instructions',
        element: <InstrSurgeryPage />,
      },
      {
        path: 'instructions/homebleaching',
        element: <HomebleachingPage />,
      },
      {
        path: 'agenda',
        element: <AgendaPage />,
      },
      {
        path: 'agenda-weekly',
        element: <AgendaWeeklyPage />,
      },
      {
        path: 'admin-booking',
        element: <AdminBookingPage />,
      },
      {
        path: 'new-patient-data',
        element: <NewPatientDataPage />,
      },
      {
        path: 'registration-done',
        element: <RegistrationDonePage />,
      },
      {
        path: 'cancellation',
        element: <CancellationPage />,
      },
      {
        path: 'cancellation-done',
        element: <CancellationDonePage />,
      },
      {
        path: 'appointment-chain',
        element: <AppointmentChainPage />,
      },
      {
        path: 'profile',
        element: <ProfilePage />,
      },
      {
        path: 'contact',
        element: <ContactPage />,
      },
    ],
  },
]);

export function Routes() {
  return (
    <div className={`route-shell inline-flex flex-col text-left px-4 py-3 rounded-md border-1 border-transparent`}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </div>
  );
}
